
export const formatMoney = (num: number, hideTrailingZeroes?: boolean) => {
  const n = new Intl.NumberFormat(
    'en-CA',
    { style: 'currency', currency: 'CAD' }
  ).format(num / 100);
  if (hideTrailingZeroes) {
    return n.replace(/\.00$/, '');
  } else {
    return n;
  }
};

